import React from 'react';
import md5 from 'js-md5';
import { ExportCenter } from '@components/exportCenter';
import RootRouter, { StandalonePagesConfigProp } from '@ywfe/yw-router';
import ComponentLoader from '@components/component.loader';
import { getEnv } from '@ywfe/utils';
import { Login } from './auth/login';
import { User } from './auth';
// AI router
import AiChatExit from './aiChat/exit';
import { standalonePages } from './standalonePages.config';
import TaskPlatformUmd from './taskPlatform/taskPlatformUmd';
import './App.css';

(window as any).md5 = md5;

const GetQueryString = (name: string) => {
  const url = window.location.href;
  const reg = new RegExp(`(\\?|&)${name}=([^&]*)(&|$)`, 'i');
  const r = url.match(reg);

  if (r !== null) {
    return unescape(r[2]);
  }
  return '';
};

// 全局调试模式
// const isDebug = GetQueryString('debug') === 'true' || sessionStorage.getItem('debug') === 'true';
// isDebug && console.log('开启Debug模式');
// if (!isDebug) {
//   (window as any).console = {
//     log: () => {},
//     error: () => {},
//     info: () => {},
//     warn: () => {},
//   };
// }

const menus = [
  {
    url: '/',
    path: '/',
    name: 'desktop',
    meta: {
      title: '桌面',
      icon: 'ywcloudIconshouye',
    },
    component: () => <ComponentLoader componentPath="/ywwl/home" />,
  },
  {
    url: '/taskPlatform',
    path: '/taskPlatform',
    name: '_taskPlatform',
    meta: {
      title: '任务中心',
    },
    component: TaskPlatformUmd,
    hidden: true,
  },
  {
    url: '/login',
    path: '/login',
    name: '_login',
    meta: {
      title: '登陆',
    },
    component: Login,
    hidden: true,
  },
];

const logo = <img src="https://yw-yx.oss-cn-hangzhou.aliyuncs.com/lanhai/yun19%402x.png" alt="遥望云" width={32} height={32} />;

if (typeof window !== undefined && window.location.search.includes('token=')) {
  localStorage.setItem('token', GetQueryString('token'));
}

// AI 窗口定位信息缓存
if (typeof window !== undefined && window.location.search.includes('wxMsgType=ai')) {
  const item: any = {
    bizNo: GetQueryString('targetId'),
  };
  if (GetQueryString('action') && GetQueryString('action') === 'chatRoom') {
    item.mainTaskId = GetQueryString('targetId');
    sessionStorage.setItem('aiTabTypeCache', GetQueryString('to') || 'task');
  }
  sessionStorage.setItem(
    'menuChangeCache',
    JSON.stringify({
      item,
      type: GetQueryString('action') && GetQueryString('action') === 'chatRoom' ? 'main_task' : 'chat',
      // tabType: GetQueryString('to'),
      isFinished: GetQueryString('isFinished') || '',
    }),
  );
  window.location.href = `/aiChat/${GetQueryString('to')}`;
}

// 判断终端
const isPad =
  navigator.userAgent.includes('iPad') ||
  (navigator.userAgent.toLowerCase().includes('macintosh') && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
if (isPad) {
  localStorage.setItem('isiPad', 'true');
} else {
  // localStorage.removeItem('isiPad')
}

// 识别AI跳转
if (
  typeof window !== undefined &&
  (window.location.search.includes('/aiChat') || window.location.href.includes('/aiChat')) &&
  window.localStorage.getItem('token')
) {
  const env = getEnv();
  if (env !== 'prod') {
    window.open(`//aichat-${getEnv()}.ywwl.com/aiChat?token=${window.localStorage.getItem('token')}`, '_self');
  } else {
    window.open(`//aichat.ywwl.com/aiChat?token=${window.localStorage.getItem('token')}`, '_self');
  }
}

// const App: React.FC = () => (
//   <YSystem>
//     <ExportCenter />
//     <YLayout config={{ logo, menus }} />
//   </YSystem>
// );
const renderAiChar = () => (
  // const isGray = localStorage.getItem('isGray');
  // if (isGray === 'true') {
  //   return (
  //     <YwAiChat
  //       firstSwitch
  //       autoSend={false}
  //       hiddenPages={['/login', '/aiChat', ...(standalonePages || []).map((item: any) => item.path)]}
  //       isFullScreen
  //       canClose
  //       singleScenes={2}
  //       isNewVersion
  //       // scenes='taskChat'
  //       bizType="ywGroup"
  //       platform="ywyun"
  //     />
  //   );
  // }
  // return (
  //   <YwAiChat
  //     firstSwitch
  //     autoSend={false}
  //     hiddenPages={['/login', '/aiChat', ...(standalonePages || []).map((item: any) => item.path)]}
  //     isFullScreen
  //     canClose
  //     singleScenes={2}
  //     scenes="taskChat"
  //     bizType="ywGroup"
  //     platform="ywyun"
  //   />
  // );
  <AiChatExit hiddenPages={['/login', '/aiChat', '_companyDataView_employeeView', ...(standalonePages || []).map((item: any) => item.path)]} />
);
// return <></>;
const App: React.FC = () => (
  <>
    <RootRouter
      config={{
        logo,
        menus,
        standalonePages: standalonePages as StandalonePagesConfigProp[],
        authComponent: <User />,
      }}
    >
      <ExportCenter />
      {renderAiChar()}
    </RootRouter>
  </>
);

export default App;

/*eslint-disable*/
// @ts-ignore
Function.prototype.before = function (fn) {
  const __self = this;
  return function () {
    // @ts-ignore
    fn.apply(this, arguments);
    __self.apply(__self, arguments);
  };
};
// @ts-ignore
Function.prototype.after = function (fn) {
  const __self = this;
  return function () {
    __self.apply(__self, arguments);
    // @ts-ignore
    fn.apply(this, arguments);
  };
};
